import request from "../api/agent";

export class SftpHouseKeepingService {
  async getSftpHouseKeepingLogs({
    id,
    page,
    limit,
    partners,
    clients,
    filename,
    folder,
    status,
    show_all_records,
    start_date_range,
    end_date_range,
    started_at_range,
    completed_at_range,
    export_type,
    header_names
  }) {
    const params = {
      ...(id ? { id, housekeeping_id: id } : {}),
      page,
      limit,
      partners: Array.isArray(partners) ? partners.join(",") : (partners || ""),
      clients: Array.isArray(clients) ? clients.join(",") : (clients || ""),
      filename: filename || "",
      folder: folder || "",
      status: Array.isArray(status) ? status.join(",") : (status || ""),
      show_all_records:show_all_records || false,
      start_date_range: start_date_range || "",
      end_date_range: end_date_range || "",
      started_at_range: started_at_range || "",
      completed_at_range: completed_at_range || "",
      export: export_type ? "true" : "false",
      header_names: Array.isArray(header_names) ? header_names.join(",") : (header_names || "")
    };

    const response = await request.get("reports/house-keeping/retireve-sftp-archive-removal-logs", { params });
    return response.data ?? response?.response?.data;
  }

  async getRetrieveSftpHouseKeepingLogs({
    page,
    limit,
    type,
    date,
    export_type,
    header_names
  }) {
    const params = {
      page,
      limit,
      type: Array.isArray(type) ? type.join(",") : (type || ""),
      date_range: date || "",
      export: export_type ? "true" : "false",
      header_names: Array.isArray(header_names) ? header_names.join(",") : (header_names || "")
    };

    const response = await request.get("reports/house-keeping/retireve-sftp-house-keeping", { params });
    return response.data ?? response?.response?.data;
  }

  async getHouseKeepingLog(path) {
    const params = { path };
    const response = await request.post("reports/house-keeping/get-house-keeping-log",  params );
    return response.data ?? response?.response?.data;
  }
}
